import { Chip, Grid } from "@mui/material";
import EditAction from "../components/edit-action/edit-action";
import DeleteAction from "../components/delete-action/delete-action";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { dateString } from "@/common/components/TableView/helpers/helpers";
const {energyTypeTabMasterKey} = requestedMenuAll;
const {updateKey, deleteKey} = requestedFeaturesAll;

export const columns = ({onRowEdit, onRowDelete, deleteCategoryMasterStatus, isUpdateDeleteAccess
}) => ([...[
  {
    header: 's-no',
    accessorKey: 'energyTypeId',
    cell: (value) => {
      const energyTypeId = value.row.index + 1;
     return energyTypeId;
    }
  },
  {
    header: 'vehicle-cat-name',
    accessorKey: 'vehicleCatName'
  },
  {
    header: 'vehicle-cat-code',
    accessorKey: 'vehicleCatCode'
  },

  {
    header: 'transport-mode',
    accessorKey: 'transPortModeName'
  },
  {
    header: 'created-at',
    hideColumn: true,
    accessorKey: 'createdAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'created-by',
    hideColumn: true,
    accessorKey: 'createdBy'
  },
  {
    header: 'updated-at',
    hideColumn: true,
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'updated-by',
    hideColumn: true,
    accessorKey: 'updatedBy'
  },
  {
    header: 'status',
    accessorKey: 'activeStatus',
    cell: (cell) => {
      switch (cell.getValue()) {
        case '0':
          return <Chip color="error" label="In-Active" size="small" variant="light" />;
        case '1':
          return <Chip color="success" label="Active" size="small" variant="light" />;

      }
    }
  }
], ...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={energyTypeTabMasterKey} requestedFeature={updateKey}>
        <Grid item>
          <EditAction
            {...props}
            onRowEdit={onRowEdit}
          />
        </Grid>
        </VerifyAccess>
        <VerifyAccess requestedMenu={energyTypeTabMasterKey} requestedFeature={deleteKey}>
        <Grid item>
          <DeleteAction
            {...props}
            onRowDelete={onRowDelete} deleteCategoryMasterStatus={deleteCategoryMasterStatus}
          />
        </Grid>
        </VerifyAccess>

      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }


]:[])]);

export const reportFileName = "Energy Type Master";


